import React from "react";
import { FaPhone } from "react-icons/fa";

function EmergencyContactCard({ contact }) {
  return (
    <a
      href={`tel:${contact.contactNumber}`}
      className="block w-full bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-300 transform hover:scale-[1.02] border-l-4 border-[#FF4B4B]"
    >
      <div className="p-4 flex items-center justify-between">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-[#363062] mb-1">
            {contact.name}
          </h3>
          <p className="text-sm text-gray-600 mb-2">{contact.title}</p>
          <div className="flex items-center gap-2 text-[#FF4B4B] font-medium">
            <FaPhone className="w-4 h-4" />
            <span>{contact.contactNumber}</span>
          </div>
        </div>
        <div className="flex-shrink-0 ml-4">
          <div className="bg-[#FF4B4B] text-white p-3 rounded-lg shadow-sm hover:bg-[#FF3131] transition-colors">
            <FaPhone className="w-5 h-5" />
          </div>
        </div>
      </div>
    </a>
  );
}

export default EmergencyContactCard;
